module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cholesterolView"
  }, [(_vm.$store.state.user.scope) ? _c('cholesterol-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [(_vm.$store.state.user.settings) ? _c('cholesterol-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "blood_glucose": _vm.$store.state.user.settings.blood_glucose
    }
  }, [_vm._v("\n        >\n      ")]) : _vm._e(), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "cholesterol"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  }), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "icon": "filter_list",
      "autoWidth": ""
    },
    model: {
      value: (_vm.activeFilter),
      callback: function($$v) {
        _vm.activeFilter = $$v
      },
      expression: "activeFilter"
    }
  }, _vm._l((_vm.filters), function(filter, index) {
    return _c('mu-menu-item', {
      key: 'tracking-filter-' + index,
      attrs: {
        "value": filter.key,
        "title": filter.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.determineColor(item),
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [(_vm.activeFilter === 'TOTAL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.total_mmoll + ' mmol/L' : item.total_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'LDL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.ldl_mmoll + ' mmol/L' : item.ldl_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'HDL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.hdl_mmoll + ' mmol/L' : item.hdl_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'TRIGLYCERIDES') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.triglycerides_mmoll + ' mmol/L' : item.triglycerides_mgdl + ' mg/dL')
        }
      })]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('cholesterol-edit', {
        attrs: {
          "preference": _vm.data.preference,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d59a204","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/Cholesterol.vue
// module id = 3823
// module chunks = 1